export const TabContentGrid = ({ children }) => (
  <div className="grid min-[600px]:max-sm:grid-cols-2 list-md:grid-cols-2 2xl:max-3xl:grid-cols-3 3xl:grid-cols-4 gap-6">
    {children}
  </div>
);
